module.exports = __webpack_public_path__ + "img/team.b0d69bfb.svg";